/*
 * Copyright (c) 2021. FINN Sp. z o.o.
 */

package pl.finn.forms.model

import io.kvision.form.FormType
import io.kvision.html.div
import io.kvision.html.main
import io.kvision.panel.SimplePanel
import io.kvision.state.bind
import kotlinx.coroutines.*
import pl.finn.forms.generator.CatalogPanel
import pl.finn.forms.generator.DocumentFormModel
import pl.finn.forms.generator.FormView
import pl.finn.forms.utils.form.extendedPanel
import kotlin.coroutines.CoroutineContext

class FormTemplate : SimplePanel(), CoroutineScope {

  private var job: Job = Job()

  override val coroutineContext: CoroutineContext
    get() = Dispatchers.Main + job

  private val formComponents = FormComponents()

  init {
    bind(DocumentFormModel.storeReduxForm) { state ->
      main {
        id = "peupcontent"
        state.bladZapisu?.let {
          div(it, className = "alert alert-danger") {
            role = "alert"
          }
        }
        when (state.view) {
          FormView.EDIT_FORM, FormView.NEW_FORM -> {
            if (state.elements != null) {
              extendedPanel<DocumentTreeNode>(
                type = FormType.INLINE, className = "mx-2 mx-md-5 mt-3"
              ) {
                add(formComponents.createButtonPanel(state, this@extendedPanel))
                launch {
                  add(CatalogPanel(state, this@extendedPanel).createForm())
                }
                if (!state.attachments.isNullOrEmpty()) {
                  add(formComponents.createAttachmentsTable(state, this@extendedPanel))
                }
              }
            }
          }
          else -> {
            // 'When' expression on enum is recommended to be exhaustive
          }
        }
      }
    }
  }
}